export function createElement(tagName, text, attrs = {}) {
  const element = document.createElement(tagName);

  element.textContent = text;

  for (const [key, value] of Object.entries(attrs)) {
    if (tagName === 'option' && key === 'selected' && !value)
      continue;

    element.setAttribute(key, value);
  }

  return element;
}

export function createForm(method, action, fields) {
  const csrfParam = getMetaContent('csrf-param');
  const csrfToken = getMetaContent('csrf-token');

  const form = createElement('form', '', { action, method: 'POST' });

  form.appendChild(createElement('input', '', {
    type: 'hidden', name: '_method', value: method
  }));

  if (csrfParam && csrfToken) {
    form.appendChild(createElement('input', '', {
      type: 'hidden', name: csrfParam, value: csrfToken
    }));
  }

  for (let name in fields) {
    const value = fields[name];

    form.appendChild(createElement('input', '', {
      type: 'hidden', name, value
    }));
  }

  return form;
}

export function getMetaContent(name) {
  const meta = document.querySelector(`meta[name="${name}"]`);

  if (meta) {
    return meta.content;
  }
}


function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === "complete" || document.readyState === "interactive") {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}
